import * as Yup from "yup";

export const productPriceHistorySchema = Yup.object().shape({
  price: Yup.number().required("Campo requerido"),
  cost: Yup.number().required("Campo requerido"),
  effectiveFrom: Yup.date().required("Campo requerido"),
  effectiveTo: Yup.date().nullable(),
});
